/**
 * Component name of the `ResourceList`
 *
 * This needs to be a in separate file to avoid circular dependency of
 * index.vue --> resource-fetch mixin --> resource-fetch-namespaced mixin --> index.vue
 */
export const ResourceListComponentName = 'ResourceList';
